import fetch from 'isomorphic-unfetch';

const sendContact = async (values) =>
  await fetch('/contact', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });

export { sendContact };
